import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=6af5a971&scoped=true&lang=pug&"
import script from "./CardList.vue?vue&type=script&lang=ts&"
export * from "./CardList.vue?vue&type=script&lang=ts&"
import style0 from "./CardList.vue?vue&type=style&index=0&id=6af5a971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5a971",
  null
  
)

export default component.exports